import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";

// export const firebaseConfig = {
//     apiKey: "AIzaSyBsPPhHPV7jJw9oEdmqhBTPnh6WUNQ2_6s",
//     authDomain: "polling-app-ux.firebaseapp.com",
//     projectId: "polling-app-ux",
//     storageBucket: "polling-app-ux.appspot.com",
//     messagingSenderId: "894491090593",
//     appId: "1:894491090593:web:7a399818abe85bf877dae0",
//     measurementId: "G-859V7NTJHR"
// };

const firebaseConfig = {
  apiKey: "AIzaSyCqcUHxkx9Zz0zgtd1Ad9Xp5NmYnCMLOj4",
  authDomain: "polling-app-3a7d5.firebaseapp.com",
  projectId: "polling-app-3a7d5",
  storageBucket: "polling-app-3a7d5.appspot.com",
  messagingSenderId: "639969091739",
  appId: "1:639969091739:web:7a203ab67e1d5d23e1a63e",
  measurementId: "G-JJG8GGLBNJ"
};


export const initializeFirebase = () => {
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  return app
}
